export default __webpack_public_path__ + "static/media/logo.d3b35ad9.jpeg";